import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonAlignRight} from 'mui-tiptap';

const StyledEditorMenuButtonAlignRight = styled(MenuButtonAlignRight)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonAlignRight.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonAlignRight;
